/**
 * A list of badges, with no output for empty lists.
 *
 * Centralizes the empty-list guard to avoid inconsistent behavior across
 * call sites.
 * @module components/Badge/Badges
 */
import React from 'react';
import Badge from './Badge';

import './Badges.scss';

interface BadgesProps {
  /** Badge titles, in the order the backend returned them. */
  items?: string[];
}

const Badges: React.FC<BadgesProps> = ({ items }) => {
  if (!items?.length) {
    return null;
  }
  return (
    <div className="badges">
      {items.map((item) => (
        // A badge is its title on the backend, so the title is a unique key.
        <Badge key={item} title={item} />
      ))}
    </div>
  );
};

export default Badges;
